import PropTypes from 'prop-types';
import { RecordContextProvider, useTranslate } from 'react-admin';
import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RightDrawer } from '@/components/global/drawers/RightDrawer';
import { BrandForm } from '@/components/brand/forms/BrandCreate.jsx';
import { UniqueFieldIds } from '@/components/retailChain/forms/UniqueFieldIds.jsx';
import { retailChainBrandDraftStyles } from '@/themes/commonStyles/retailChainForm.js';

const EMPTY_BRAND_RECORD = {};
const StyledBrandDraft = styled(Box)(retailChainBrandDraftStyles);

export const RetailChainBrandDraft = ({ onClose, onSave, lockedRetailChain = null }) => {
    const translate = useTranslate();

    const closeOnEscape = event => {
        if (event.key !== 'Escape') {
            return;
        }

        event.stopPropagation();
        onClose();
    };

    return (
        <StyledBrandDraft onKeyDown={closeOnEscape}>
            <Box className='retail-chain-brand-draft__backdrop' onClick={onClose} />
            <Paper className='custom-dialog-right custom-dialog-right--medium' elevation={16} square>
                <Box className='custom-dialog-right__inner'>
                    <UniqueFieldIds prefix='brand-draft-'>
                        <RightDrawer handleClose={onClose} title={translate('resources.brand.labels.create')}>
                            <RecordContextProvider value={EMPTY_BRAND_RECORD}>
                                <BrandForm handleClose={onClose} showRetailChain={false} lockedRetailChain={lockedRetailChain} onSubmit={onSave} />
                            </RecordContextProvider>
                        </RightDrawer>
                    </UniqueFieldIds>
                </Box>
            </Paper>
        </StyledBrandDraft>
    );
};

RetailChainBrandDraft.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    lockedRetailChain: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string,
    }),
};
